import BaseModel from "./BaseModel";

class CourseModel extends BaseModel {
    pathname = "api-b2b/v1/course";

    getCourseDetail = (course_id) => {
        return this.get({
            path: `${this.pathname}/${course_id}`,
        });
    };

    getSubjectDetail = (course_id, subject_id) => {
        return this.get({
            path: `${this.pathname}/${course_id}/subject/${subject_id}`,
        });
    };

    postSubjectIsViewed = (course_id, subject_id) => {
        return this.post({
            path: `${this.pathname}/${course_id}/subject/${subject_id}`,
        });
    };

    putSubjectViewedDuration = (course_id, subject_id, study_duration) => {
        return this.put({
            headers: {
                "Content-Type": "application/json",
            },
            path: `${this.pathname}/${course_id}/subject/${subject_id}`,
            params: {
                second: study_duration,
            },
        });
    };
}

export default CourseModel;
